import type {
    ILeidseSchema,
    IOrthOProcedureCustomControlData,
    IVisusBcvaFields,
    IVisusCcFields,
    IVisusEcFields,
    IVisusScFields,
} from '@common/interfaces/ophthalmology/orthO/orthOProcedureCustomControlData';

export function orthOV1ProcedureInitializeCustomControlData(): IOrthOProcedureCustomControlData {
    return {
        verwijzer: null,
        verwijzer_overig: null,
        klachten_en_of_reden_van_bezoek: null,
        algemene_gezondheid_en_medicatie: null,
        oculaire_voorgeschiedenis: null,
        huidige_brilsterkte_od: null,
        huidige_brilsterkte_os: null,
        familiaire_voorgeschiedenis: null,
        isPatientInformed: false,
        algemene_observatie_gezicht: null,
        lichtreflex: null,
        covertest_30cm: null,
        covertest_6m: null,
        prismacovertest_30cm: null,
        prismacovertest_6m: null,
        stereotest: null,
        prismatest_15: null,
        prismatest_omgekeerde: null,
        four_dot_test: null,
        convergentietest: null,
        oogbewegingen: null,
        visusGroup: {
            visus_sc: false,
            visus_cc: false,
            visus_bcva: false,
            visus_ec: false,
        },
        leidse_schema: { ...initialLeidseschemaFields },
        leidse_schema_toelichting: null,
        ...initialVisusCcFields,
        ...initialVisusScFields,
        ...initialVisusEcFields,
        visus_ec_refractie_sferisch_od: null,
        visus_ec_refractie_sferisch_os: null,
        visus_ec_refractie_cylindrisch_od: null,
        visus_ec_refractie_cylindrisch_os: null,
        visus_ec_refractie_as_od: null,
        visus_ec_refractie_as_os: null,
        visus_ec_refractie_additie_od: null,
        visus_ec_refractie_additie_os: null,
        visus_ec_refractie_prisma_od: null,
        visus_ec_refractie_prisma_os: null,
        visus_ec_refractie_prisma_degrees_od: null,
        visus_ec_refractie_prisma_degrees_os: null,
        ...initialVisusBcvaFields,
        visus_pinhole_od: null,
        visus_pinhole_os: null,
        refractie_sferisch_od: null,
        refractie_cylindrisch_od: null,
        refractie_as_od: null,
        refractie_additie_od: null,
        refractie_prisma_od: null,
        refractie_prisma_degrees_od: null,
        refractie_sferisch_os: null,
        refractie_cylindrisch_os: null,
        refractie_as_os: null,
        refractie_additie_os: null,
        refractie_prisma_os: null,
        refractie_prisma_degrees_os: null,
        autorefractie_sferisch_od: null,
        autorefractie_cylindrisch_od: null,
        autorefractie_as_od: null,
        autorefractie_additie_od: null,
        autorefractie_prisma_od: null,
        autorefractie_prisma_degrees_od: null,
        autorefractie_sferisch_os: null,
        autorefractie_cylindrisch_os: null,
        autorefractie_as_os: null,
        autorefractie_additie_os: null,
        autorefractie_prisma_os: null,
        autorefractie_prisma_degrees_os: null,
        autorefractie_cyclo_sferisch_od: null,
        autorefractie_cyclo_cylindrisch_od: null,
        autorefractie_cyclo_as_od: null,
        autorefractie_cyclo_additie_od: null,
        autorefractie_cyclo_prisma_od: null,
        autorefractie_cyclo_prisma_degrees_od: null,
        autorefractie_cyclo_sferisch_os: null,
        autorefractie_cyclo_cylindrisch_os: null,
        autorefractie_cyclo_as_os: null,
        autorefractie_cyclo_additie_os: null,
        autorefractie_cyclo_prisma_os: null,
        autorefractie_cyclo_prisma_degrees_os: null,
        skiascopie_cyclo_sferisch_od: null,
        skiascopie_cyclo_cylindrisch_od: null,
        skiascopie_cyclo_as_od: null,
        skiascopie_cyclo_sferisch_os: null,
        skiascopie_cyclo_cylindrisch_os: null,
        skiascopie_cyclo_as_os: null,
        spleetlamp_onderzoek_od: null,
        spleetlamp_onderzoek_os: null,
        dynamische_skiascopie_onderzoek: null,
        nabije_visus_onderzoek_od: null,
        nabije_visus_onderzoek_os: null,
        nabije_visus_onderzoek_ods: null,
        glazen_bagolini: null,
        prismafusie_horizontaal_30cm: null,
        prismafusie_horizontaal_6m: null,
        prismafusie_verticaal_30cm: null,
        prismafusie_verticaal_6m: null,
        accommodatie_od: null,
        accommodatie_os: null,
        accommodatie_ods: null,
        pupil_reacties: null,
        extra_aanvullende_onderzoeken: [],
        files: [],
        hasConsultRequestFields: false,
    };
}

export const initialLeidseschemaFields: ILeidseSchema = {
    leidse_schema_1: null,
    leidse_schema_2: null,
    leidse_schema_3: null,
    leidse_schema_4: null,
    leidse_schema_5: null,
    leidse_schema_6: null,
    leidse_schema_7: null,
    leidse_schema_8: null,
    leidse_schema_9: null,
    leidse_schema_10: null,
    leidse_schema_patroon: null,
};

export const initialVisusCcFields: IVisusCcFields = {
    visus_cc_od: null,
    visus_cc_os: null,
    visus_cc_ods: null,
    visus_cc_refractie_sferisch_od: null,
    visus_cc_refractie_sferisch_os: null,
    visus_cc_refractie_cylindrisch_od: null,
    visus_cc_refractie_cylindrisch_os: null,
    visus_cc_refractie_as_od: null,
    visus_cc_refractie_as_os: null,
    visus_cc_refractie_additie_od: null,
    visus_cc_refractie_additie_os: null,
    visus_cc_refractie_prisma_od: null,
    visus_cc_refractie_prisma_os: null,
    visus_cc_refractie_prisma_degrees_od: null,
    visus_cc_refractie_prisma_degrees_os: null,
};

export const initialVisusScFields: IVisusScFields = {
    visus_sc_od: null,
    visus_sc_os: null,
    visus_sc_ods: null,
};

export const initialVisusEcFields: IVisusEcFields = {
    visus_ec_od: null,
    visus_ec_os: null,
    visus_ec_ods: null,
};

export const initialVisusBcvaFields: IVisusBcvaFields = {
    visus_bcva_od: null,
    visus_bcva_os: null,
    visus_bcva_ods: null,
    visus_bcva_refractie_sferisch_od: null,
    visus_bcva_refractie_sferisch_os: null,
    visus_bcva_refractie_cylindrisch_od: null,
    visus_bcva_refractie_cylindrisch_os: null,
    visus_bcva_refractie_as_od: null,
    visus_bcva_refractie_as_os: null,
    visus_bcva_refractie_additie_od: null,
    visus_bcva_refractie_additie_os: null,
    visus_bcva_refractie_prisma_od: null,
    visus_bcva_refractie_prisma_os: null,
    visus_bcva_refractie_prisma_degrees_od: null,
    visus_bcva_refractie_prisma_degrees_os: null,
};

export function getInitialVisusFields(
    visusGroup: keyof IOrthOProcedureCustomControlData['visusGroup']
): IVisusEcFields | IVisusScFields | IVisusCcFields | IVisusBcvaFields {
    switch (visusGroup) {
        case 'visus_cc':
            return initialVisusCcFields;
        case 'visus_ec':
            return initialVisusEcFields;
        case 'visus_sc':
            return initialVisusScFields;
        default:
            return initialVisusBcvaFields;
    }
}

export const initialConsultRequestFieldsForOrthO = {
    consult: {
        selectedDiagnosticReportProviderOrganizationId: null,
        selectedDiagnosticReportProviderPractitionerId: null,
        toelichting: null,
        question: null,
        evaluation: {
            otherwiseReferPatient: null,
        },
    },
};
